module.exports = "<div class=\"rcu-management-wrapper admin-page\"><div><section><datausage></datausage></section></div></div>";